import React, { useContext, useState, useEffect } from 'react';
import '../../styles/Profile.scss';
// import { MdOutlineHistory } from 'react-icons/md';
import { TbLogout2 } from 'react-icons/tb';
import { useSessionContext } from '../../security/context/SessionContext'; 
import { logout } from '../../security/actions'; 
import { getTokenOrDefault } from '../../helpers/Storage'; 
import { tryFetch } from '../../helpers/FetchAPI'; 
// import { useProfile } from '../hooks/useProfile';
  
  interface ContactInfo {
	contact_id: string;
	label: string;
	contact_name: string;
	contact_phone: string;
	contact_email_address: string;
  }

const Profile = () => {
	const { session, setSession } = useSessionContext();

       const TbLogout = TbLogout2 as React.ElementType;

	useEffect(() => {
		const fetchContacts = async () => {
	
		};
	
		fetchContacts();
	  }, []);

	const handleLogout = async () => {
		const token = getTokenOrDefault();
		const response = await logout(token);
		if(response.is_success) {
			setSession({
				isAuthenticated: false,
				user: null
			});
		}
	};

	return (
		<React.Fragment>
			{session.user !== null ? (
				<div className="profile-container">
					<h2 className="profile-title">Profile</h2>
					<div className="profile-icons">
						{/* <div className="icon">
							<MdOutlineHistory className="icon-image" size="30" />
						</div> */}
					</div>
					<hr className="profile-divider" />
					<p className="profile-detail"><strong>Full Name:</strong> {session.user.first_name} {session.user.last_name}</p>
					<p className="profile-detail"><strong>Email:</strong> {session.user.email_address}</p>
					<hr className="profile-divider" />

					<button onClick={handleLogout} className="logout-button">
						<TbLogout className="logout-icon" /> Logout
					</button>
				</div>
			) : <p>Loading...</p>}
		</React.Fragment>

	);
};

export default Profile;